import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"

export interface PushDocumentRequest {
  documentId: string
  subject: string
  contentCategoryTypeCode?: string
  zoneCode?: string
  sensitivityCode?: string
}

export interface PushDocumentResponse {
  success: boolean
  message: string
  pushId?: string
}

export interface DocPushStatusResponse {
  pushId: string
  documentId: string
  employeeId: string
  status: string
  isTerminal: boolean
  isSuccess: boolean
  lastErrorPayload: string | null
  createdAt: string
  updatedAt: string
}

export async function pushDocument(
  organizationId: string,
  employeeId: string,
  dto: PushDocumentRequest,
): Promise<PushDocumentResponse> {
  const response = await apiClient.post<PushDocumentResponse>(
    `/organizations/${organizationId}/sage300/employees/${employeeId}/documents/push`,
    dto,
  )
  return response.data
}

export async function getDocumentPushStatus(
  organizationId: string,
  pushId: string,
): Promise<DocPushStatusResponse | null> {
  try {
    const response = await apiClient.get<DocPushStatusResponse>(
      `/organizations/${organizationId}/sage300/documents/push/${pushId}`,
    )
    return response.data
  } catch (err: unknown) {
    const status =
      typeof err === "object" && err !== null
        ? ((err as { response?: { status?: number } }).response?.status ?? 0)
        : 0
    if (status === HttpStatusCodes.NOT_FOUND) return null
    throw err
  }
}

export const sage300DocumentService = {
  pushDocument,
  getDocumentPushStatus,
}
